<template>
  <div class="send-cart" @click.stop>
    <form @submit.prevent="sendCart" class="input-group">
      <input v-focus v-model="email" :placeholder="titles.email" class="form-control" type="text" />
      <span class="input-group-append">
        <input class="btn btn-outline-secondary text-dark" type="submit" value="OK" />
        <a class="btn btn-outline-secondary text-dark" @click.prevent="cancelSend">X</a>
      </span>
    </form>

    <div v-if="!sent" v-translate>
      * L'envoi d'une sélection ne peut se faire qu'à un utilisateur ayant un compte Navigart
    </div>
    <div class="error" v-if="sent && not_valid.length === 1">
      {{ not_valid }}
      <br />
      {{ not_valid.join(',') }}
      <span v-translate>n'est pas reconnu comme un utilisateur Navigart3.</span>
      <br />
      <span v-translate>Demandez à votre interlocuteur de créer un compte.</span>
      <br />
      <span v-translate>Ce message ne liste pas les mails valides.</span>
    </div>

    <div class="error" v-if="sent && not_valid.length >= 2">
      {{ not_valid.join(',') }}
      <span v-translate>ne sont pas reconnus comme des utilisateurs Navigart3.</span>
      <br />
      <span v-translate>Demandez à vos interlocuteurs de créer un compte.</span>
      <br />
      <span v-translate>Ce message ne liste pas les mails valides.</span>
    </div>

    <div class="message" v-if="sent && not_valid.length === 0" v-translate>Sélection envoyée</div>

    <div class="error" v-if="sent && errors.length > 0">
      <br />
      <span v-translate>There was a problem to send a cart to</span>
      {{ errors.join(',') }}
    </div>
  </div>
</template>

<script>
import Carts from 'api/carts';
import toastr from 'mixins/toastrMixin.js';

export default {
  name: 'CartSend',
  props: {
    cart: {
      type: Object,
      required: true,
    },
  },
  mixins: [toastr],
  methods: {
    async sendCart() {
      if (!this.email) return;
      const data = await Carts.send(this.cart.id, { email: this.email });
      if (data.valid.length) {
        this.toastr('cartSent');
        this.$emit('sendCart', false);
      } else {
        this.email = '';
        this.sent = true;
        this.errors = data.errors;
        this.not_valid = data.not_valid;
      }
    },
    cancelSend() {
      this.$emit('sendCart', false);
    },
  },
  computed: {
    titles() {
      return {
        email: this.$gettext('Mail du compte Navigart* du destinataire'),
      };
    },
  },
  data() {
    return {
      sent: false,
      email: '',
      errors: [],
      valid: [],
      not_valid: [],
    };
  },
};
</script>
